import { CommonModule } from "@angular/common";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AppUrlService } from "./nav/app-url.service";
import { AppAuthService } from "./auth/app-auth.service";
import { AppRouteGuard } from "./auth/auth-route-guard";
import { AppRouteGuardV1 } from "./auth/auth-route-guard.v1";
import { TranslationService } from "@shared/translation.service";
import { AnonymousRouteGuard } from "@shared/auth/anonymous-route-guard";
import { AbpModule } from "abp-ng2-module";
import { EditionService } from "@subscription/edition";
import { SubscriptionApiModule } from "@subscription/api";
import { VindiTenantDebtLock } from "@subscription/debt-lock";
import { AppSessionService, TenantDebtLock } from "@vadmin/account/auth";
import {
    SessionServiceProxy,
    TokenAuthServiceProxy,
    EditionServiceServiceProxy,
    HealthTenantServiceProxy,
    UserServiceProxy,
} from "@api/core";

@NgModule({
    imports: [CommonModule, AbpModule, RouterModule, SubscriptionApiModule],
    declarations: [],
    exports: [],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                EditionService,
                { provide: TenantDebtLock, useClass: VindiTenantDebtLock },
                AppSessionService,
                SessionServiceProxy,
                TokenAuthServiceProxy,
                HealthTenantServiceProxy,
                EditionServiceServiceProxy,
                UserServiceProxy,
                AppUrlService,
                AppAuthService,
                AppRouteGuard,
                AnonymousRouteGuard,
                AppRouteGuardV1,
                TranslationService,
            ],
        };
    }
}
